<template>
  <div id="app">
    <!-- <banner-environment/> -->
    <!-- <br /> -->
    <layout-broker :name="layout">
      <router-view />
    </layout-broker>
  </div>
</template>

<script>
import LayoutBroker from '@/layouts/broker'
import BannerEnvironment from '@/components/navigation/banner-environment'

export default {
  name: 'app',
  components: {
    LayoutBroker,
    BannerEnvironment
  },
  mounted() {
    let version = window.version ? window.version : ''
    console.log('Version:', version)
  },
  computed: {
    layout() {
      return this.$route.meta && this.$route.meta.layout ? this.$route.meta.layout : 'no-nav'
    }
  }
}
</script>

<style lang="scss">
@import '../src/assets/sass/custom.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue